// currencyUtils.js
export const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    AUD: 'A$',
    CAD: 'C$',
    INR: '₹',
    SGD : 'S$'
};

// Prices predefined for each currency
export const prices = {
    USD: {
        baseCostPerUser: {
            'New User Request': 30, 
            'New User Copy Request': 30, 
            'New User Copy Layout Request': 125 ,
            'User Copy Layout Only Request' : 95,
            'Connection Request' : 25
        },
        services: [
            { id: 'Example Service 1', name: 'Example Service 1', cost: 10 },
            { id: 'Example Service 2', name: 'Example Service 2', cost: 20 },
            { id: 'Example Service 3', name: 'Example Service 3', cost: 15 },
        ],
        productTypes: [
            { id: 'C9 Trader', label: 'C9 Trader', cost: 225 },
            { id: 'C9 Desk', label: 'C9 Desk', cost: 60 },
            { id: 'C9 Desk Plus', label: 'C9 Desk Plus', cost: 135 },
            { id: 'C9 Ambient', label: 'C9 Ambient', cost: 100 },
            { id: 'Instant Voice', label: 'Instant Voice', cost: 60 },
        ],
        recordingStoragePrices: {
            Cloud: 60,
            Local: 50,
            CloudLocal: 75
        },
        dialTonePrice: 20,
        voiceRetentionPrice: 15
    },
    EUR: {
        baseCostPerUser: {
            'New User Request': 30, 
            'New User Copy Request': 30, 
            'New User Copy Layout Request': 125 ,
            'User Copy Layout Only Request' : 95,
            'Connection Request' : 25
        },
        services: [
            { id: 'Example Service 1', name: 'Example Service 1', cost: 9 },
            { id: 'Example Service 2', name: 'Example Service 2', cost: 18 },
            { id: 'Example Service 3', name: 'Example Service 3', cost: 14 },
        ],
        productTypes: [
            { id: 'C9 Trader', label: 'C9 Trader', cost: 195 },
            { id: 'C9 Desk', label: 'C9 Desk', cost: 65 },
            { id: 'C9 Desk Plus', label: 'C9 Desk Plus', cost: 135 },
            { id: 'C9 Ambient', label: 'C9 Ambient', cost: 100 },
            { id: 'Instant Voice', label: 'Instant Voice', cost: 55 },
        ],
        recordingStoragePrices: {
            Cloud: 60,
            Local: 50,
            CloudLocal: 75
        },
        dialTonePrice: 20,
        voiceRetentionPrice: 15
    },
    GBP: {
        baseCostPerUser: {
            'New User Request': 25, 
            'New User Copy Request': 25, 
            'New User Copy Layout Request': 100 ,
            'User Copy Layout Only Request' : 75,
            'Connection Request' : 20
        },
        services: [
            { id: 'Example Service 1', name: 'Example Service 1', cost: 8 },
            { id: 'Example Service 2', name: 'Example Service 2', cost: 16 },
            { id: 'Example Service 3', name: 'Example Service 3', cost: 12 },
        ],
        productTypes: [
            { id: 'C9 Trader', label: 'C9 Trader', cost: 150 },
            { id: 'C9 Desk', label: 'C9 Desk', cost: 50 },
            { id: 'C9 Desk Plus', label: 'C9 Desk Plus', cost: 100 },
            { id: 'C9 Ambient', label: 'C9 Ambient', cost: 75 },
            { id: 'Instant Voice', label: 'Instant Voice', cost: 50 },
        ], 
        recordingStoragePrices: {
            Cloud: 45,
            Local: 35,
            CloudLocal: 55
        },
        
        dialTonePrice:15,
        voiceRetentionPrice: 15
    },
    SGD: {
        baseCostPerUser: {
            'New User Request': 40, 
            'New User Copy Request': 40, 
            'New User Copy Layout Request': 170 ,
            'User Copy Layout Only Request' : 130,
            'Connection Request' : 35
        },
        services: [
            { id: 'Example Service 1', name: 'Example Service 1', cost: 8 },
            { id: 'Example Service 2', name: 'Example Service 2', cost: 16 },
            { id: 'Example Service 3', name: 'Example Service 3', cost: 12 },
        ],
        productTypes: [
            { id: 'C9 Trader', label: 'C9 Trader', cost: 310 },
            { id: 'C9 Desk', label: 'C9 Desk', cost: 85 },
            { id: 'C9 Desk Plus', label: 'C9 Desk Plus', cost: 185 },
            { id: 'C9 Ambient', label: 'C9 Ambient', cost: 140 },
            { id: 'Instant Voice', label: 'Instant Voice', cost: 50 },
        ],
        recordingStoragePrices: {
            Cloud: 85,
            Local: 75,
            CloudLocal: 100
        },
        dialTonePrice:30,
        voiceRetentionPrice: 20
        
    }
};

export const getCurrencyData = (currency, formType) => {
    const currencyData = prices[currency] || prices.USD;

    return {
        symbol: currencySymbols[currency] || '$',
        pricing: {
            ...currencyData,
            baseCostPerUser: currencyData.baseCostPerUser[formType] || currencyData.baseCostPerUser.default
        }
    };
};
